import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { isLoggedIn, logout } from "./Auth/auth";
import { PrivateRoute } from "./Auth/PrivateRoute";
import { OrganisationDetail } from "./OrganisationDetail";
import { LoginForm } from "./Login/LoginForm";
import { CreateAccount } from "./Login/CreateAccount";
import { EpreuveBoard } from "./EpreuveBoard";
import { EpreuveDetail } from "./EpreuveDetail";
import { EpreuveForm } from "./Edition/EpreuveForm";
import { EventUpdate } from "./Edition/EventUpdate";
import { Navbar } from "./Components/Navbar";
import { Footer } from "./Components/Footer";
import { AccountSpace } from "./members/AccountSpace";
import { Discover } from "./calendarpage/Discover";
import { Performance } from "./calendarpage/Performance";
import { Dompter } from "./calendarpage/Dompter";
import { Nature } from "./calendarpage/Nature";

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = { loggedIn: isLoggedIn() };
  }

  handleLogin() {
    this.setState({ loggedIn: true });
    this.router.history.push("/epreuves/new");
  }

  handleLogout() {
    logout();
    this.setState({ loggedIn: false });
    this.router.history.push("/");
  }

  render() {
    const { loggedIn } = this.state;
    return (
      <Router ref={(router) => (this.router = router)}>
        <div className="mb-5">
          <Navbar
            loggedIn={loggedIn}
            onLogout={this.handleLogout.bind(this)}
            key={Date.now()}
            basketItems={[]}
          />
        </div>
        <main className="main-content">
        <div className="mx-0 row main-content">
          <div className="container visible-md">
            <Switch>
              <Route exact path="/" component={EpreuveBoard} />
              <Route exact path="/triathlon/decouverte" component={Discover} />
              <Route
                exact
                path="/triathlon/performance"
                component={Performance}
              />
              <Route exact path="/triathlon/dompter" component={Dompter} />
              <Route exact path="/triathlon/nature" component={Nature} />

              <Route
                path="/organisations/:organisationId"
                component={OrganisationDetail}
              />
              <PrivateRoute
                exact
                path="/epreuves/new"
                component={EpreuveForm}
              />
              <PrivateRoute
                exact
                path="/epreuves/update"
                component={EventUpdate}
              />
              <PrivateRoute
                exact
                path="/epreuves/compte"
                component={AccountSpace}
              />
              <Route
                path="/epreuve/:epreuveId"
                render={(props) => (
                  <EpreuveDetail {...props} key={Date.now()} />
                )}
              />
              <Route
                exact
                path="/compte/creer-compte"
                component={CreateAccount}
              />
              <Route
                exact
                path="/login"
                render={() => (
                  <LoginForm onLogin={this.handleLogin.bind(this)} />
                )}
              />
            </Switch>
          </div>
        </div>
        </main>
        <Footer />
      </Router>
    );
  }
}
